import { Country } from './../../../types'
import { RESIGNED_EMPLOYEES_OF_COMPANY_COUNTRY } from './../Queries'
import {
  ResignedEmployeesOfCompanyCountryQuery,
  ResignedEmployeesOfCompanyCountryQueryVariables,
} from './../../../../../integration-tests/common/types'
import { ApolloError, useQuery } from '@apollo/client'

export default (
  companyId: string,
  country?: Country,
): {
  data: ResignedEmployeesOfCompanyCountryQuery | undefined
  loading: boolean
  error: ApolloError | undefined
} => {
  const variables = {
    companyId,
    country,
  }
  const { data, loading, error } = useQuery<ResignedEmployeesOfCompanyCountryQuery, ResignedEmployeesOfCompanyCountryQueryVariables>(
    RESIGNED_EMPLOYEES_OF_COMPANY_COUNTRY,
    { variables },
  )
  return { data, loading, error }
}
